/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component} from '@angular/core';
import {EsciService} from '../../service/esci.service';

@Component({
    selector: 'button-cell-renderer-gps',
    styleUrls: ['./cell-renderer.component.scss'],
    template: `
    <div>
      <span
          [style]="customStyle()">{{ this.params.data[this.params.dateField] ? (this.params.data[this.params.dateField] | date: 'yyyy-MM-dd') || 'NA' : '' }}</span>
      @if (this.params.data[this.params.dateField] && showButton) {
        <span>
          <button pButton size="small" pRipple type="button" [disabled]="!enableButton"
                  [severity]="!enableButton ? 'secondary' : null"
                  class="p-button-rounded p-button-text" (click)="adjustWeeksMinusOne()"><i class="pi pi-minus" pButtonIcon></i></button>
          {{ this.params.data[this.params.adjustmentField] }}
          <button pButton size="small" pRipple type="button" [disabled]="!enableButton"
                  [severity]="!enableButton ? 'secondary' : null"
                  class="p-button-rounded p-button-text" (click)="adjustWeeksPlusOne()"><i class="pi pi-plus" pButtonIcon></i></button>
        </span>
      }
      @if (this.params.data[this.params.adjustmentField] && !showButton) {
        <span>
          ({{ this.params.data[this.params.adjustmentField] }})
        </span>
      }
    </div>
  `,
    standalone: false
})
export class ButtonCellRendererGpsComponent {
  constructor(private esciService: EsciService) {
  }

  params: any;
  showButton = false;
  enableButton = false;
  data: any;

  agInit(params: any): void {
    this.params = params;
    this.showButton = this.params.showButton ?? false;
    this.enableButton = params.data.hasAdminPermission ?? false;
  }
  // This method dynamically styles the date values based on whether they've been adjusted
  customStyle(): { [key: string]: string } {
    return {
      'font-weight': (this.params.data[this.params.adjustmentField] && this.params.data[this.params.adjustmentField] !== 0) ? 'bold' : 'normal',
    };
  }
  adjustWeeksMinusOne() {
    const current = Number(this.params.data[this.params.adjustmentField]);
    this.params.data[this.params.adjustmentField] = (Number.isFinite(current) ? current : 0) - 1;
    this.esciService.emitTimingAdjustment(this.params);
  }
  adjustWeeksPlusOne() {
    const current = Number(this.params.data[this.params.adjustmentField]);
    this.params.data[this.params.adjustmentField] = (Number.isFinite(current) ? current : 0) + 1;
    this.esciService.emitTimingAdjustment(this.params);
  }
}
